.root {
  display: flex;
  flex-direction: column;
  gap: 15px;

  .headerContainer {
    display: flex;
    flex-direction: column;
    gap: 6px;

    .header {
      display: flex;
      justify-content: space-between;
      gap: 6px;
      align-items: center;
      width: 100%;
    }
  }
}

.selectValue {
  display: flex;
  gap: 8px;
  align-items: center;
}
